const StickerType = {
    CHYRON: 'chyron',
    POSTER: 'poster',
};

export default StickerType;
